<template>
    <div @click="$emit('selected-click')" class="rounded-full text-center flex items-center" :class="style" :style="color"
        :alt="`Ligne ${name}`">
        <div class="w-full text-white">{{ name }}</div>
    </div>
</template>

<script>
export default {
    name: "Ligne",
    props: {
        name: String, // A - B - 3 - 12...
        size: String // small - medium - large
    },
    data() {
        return {
            style: "",
            color: "",
            styles: {
                long_small: ["w-6", "h-6", "text-xs"],
                long: ["w-10", "h-10", "text-xs"],
                small: ["w-6", "h-6", "text-m"],
                medium: ["w-8", "h-8", "text-xl"],
                large: ["w-10", "h-10", "text-2xl"]
            }
        };
    },
    created() {
        if (this.name.length >= 3) {
            const sizeToUse = (this.size || "medium") === "small" ? "long_small" : "long";
            this.style = this.styles[sizeToUse].join(" ");
        } else {
            this.style = this.styles[this.size || "medium"].join(" ");
        }
        // this.style = `${this.style} ligne_${this.name}`;
        this.color = `background: #${this.$store.state.linesColors[this.name]}`;
    }
};
</script>
